module.exports = __webpack_public_path__ + "static/screen_11-ab1b8710d327526c6ae457cb3a063615.png";